import { render, staticRenderFns } from "./SameCourseCard.vue?vue&type=template&id=5edb2bd4&scoped=true"
import script from "./SameCourseCard.vue?vue&type=script&lang=js"
export * from "./SameCourseCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5edb2bd4",
  null
  
)

export default component.exports